import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { LowerCasePipe } from '@angular/common';
import { DataService } from '../../services/data.service';
import { ActivatedRoute } from '@angular/router';
import { GeoJsonFeature } from '../../models/geo-json-feature';
import { Subscription } from 'rxjs';
import { getCategorySlogan } from '../../enums/category.enum';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sheet',
  imports: [TranslateModule, LowerCasePipe],
  templateUrl: './sheet.component.html',
  styleUrls: ['./sheet.component.css']
})
export class SheetComponent implements OnInit, OnDestroy {

  private translateService = inject(TranslateService);

  feature: GeoJsonFeature | undefined;
  id: number | undefined;

  // Comentado: ya no usamos relatedCategoryPoints por ahora
  // relatedCategoryPoints: MapPoint[] = [];

  private routeSub: Subscription | undefined;
  private langSub: Subscription | undefined;

  constructor(private dataService: DataService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'auto' });

    this.routeSub = this.route.params.subscribe(params => {
      this.id = +params['id'];
      if (this.id) {
        window.scrollTo({ top: 0, behavior: 'auto' });
        this.loadFeature(this.id);
      }
    });

    // Recargar ficha cuando cambie el idioma
    this.langSub = this.translateService.onLangChange.subscribe(() => {
      if (this.id) {
        this.loadFeature(this.id);
      }
    });
  }

  private getApiLang(): string | undefined {
    return this.translateService.currentLang === 'en' ? 'ing' : undefined;
  }

  loadFeature(id: number): void {
    this.dataService.getFeatureById(id, this.getApiLang()).subscribe({
      next: (feature) => {
        console.log('Ficha recibida:', feature);
        this.feature = feature;
      },
      error: (error) => {
        console.error('Error loading feature data', error);
      }
    });
  }

  // Comentado: ya no cargamos puntos relacionados por ahora
  // loadRelatedCategoryPoints(categoria: string): void {
  //   this.dataService.getDatSheerByCategory(categoria).subscribe({
  //     next: (points) => {
  //       this.relatedCategoryPoints = points;
  //     },
  //     error: (err) => {
  //       console.error('Error cargando puntos por categoría', err);
  //     }
  //   });
  // }

  ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
    this.langSub?.unsubscribe();
  }

  /** Refactor names */
  parseText(text: string): string[] {
    return text.split('@');
  }

  divideText(text: string): string[] {
    return text.split('$');
  }

  get slogan(): string {
    return getCategorySlogan(this.feature?.properties?.categoria || '');
  }

  get descripcion(): string {
    if (this.translateService.currentLang === 'en') {
      return this.feature?.properties?.descripcion_eng || this.feature?.properties?.descripcion || '';
    }
    return this.feature?.properties?.descripcion || '';
  }
}

